import React from 'react'
import classnames from 'classnames/bind'
import * as Header from 'common/modules/tpsOnlineBidBanner/header'
import * as BidDetails from 'common/modules/bidBanner/bidDetails'
import Container, {
  LeftMarginSection,
} from 'common/modules/bidBanner/container'
import FAQSection from 'common/modules/bidBanner/faqSection'
import * as CostBreakdown from 'common/modules/bidBanner/bidForm/costBreakdown'
import SalesDeposit from 'common/modules/bidBanner/bidForm/salesDeposit'
import { useListingContext } from 'common/context/listing'

const cx = classnames.bind({})
const Won = () => {
  const { segment, listing } = useListingContext()
  return (
    <Container
      ribbonColor='success'
      left={
        <>
          <div className={cx('u-mb-3')} />
          <div className={cx('u-mb-3')}>
            <Header.Won />
          </div>
          <LeftMarginSection>
            <BidDetails.After segment={segment} listing={listing} />
          </LeftMarginSection>
          <FAQSection />
        </>
      }
      right={
        <>
          <div className={cx('u-mt-4')}>
            <CostBreakdown.WinningBid
              winningBidAmount={segment?.current_highest_bid?.bid_amount}
            />
            <CostBreakdown.BuyersPremiumAndTotal
              listing={listing}
              bidAmount={segment?.current_highest_bid?.bid_amount}
            />
            <div className={cx('sales-deposit-container', 'u-mb-3')}>
              <SalesDeposit
                salesDeposit={listing.trustee?.online_state_deposit_amount || 0}
              />
            </div>
          </div>
        </>
      }
    />
  )
}
export default Won
